import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";

export const QUICK_CALCULATOR_TYPES = [
	CalculatorType.TravelInsurance,
	CalculatorType.PropertyInsurance,
	CalculatorType.CarMotoInsurance,
	CalculatorType.ConsumerLoan,
	CalculatorType.Mortgage,
] as const;
